import { Component } from '@angular/core';
import { animate, query, stagger, style, trigger, transition } from '@angular/animations';
import { ChatbotState, ChatbotStateModel } from '../../state/chatbot.state';
import { Store } from '@ngxs/store';
import { ChatbotActions } from '../../state/chatbot.actions';

@Component({
  selector: 'hf-chatbot-main',
  templateUrl: './chatbot-main.component.html',
  styleUrls: ['./chatbot-main.component.scss'],
  animations: [
    trigger('fadeInMessages', [
      transition('* => *', [
        query(
          ':enter',
          [
            style({ opacity: 0, transform: 'translateY(10px)' }),
            stagger(50, [animate('150ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))])
          ],
          { optional: true }
        )
      ])
    ])
  ]
})
export class ChatbotMainComponent {
  chatbot$ = this.store.select(ChatbotState.chatbotState);
  chatbotThinking$ = this.store.select(ChatbotState.isChatbotThinking);
  uiRendering = true;

  constructor(private readonly store: Store) {}

  public showLoadingIndicator(chatbotState: ChatbotStateModel) {
    return !chatbotState?.latestError && !chatbotState?.isNewChatState && !chatbotState?.isWarningState;
  }

  public showMainChatUI(chatbotState: ChatbotStateModel) {
    return (
      !chatbotState?.latestError &&
      !chatbotState?.isNewChatState &&
      !chatbotState?.isWarningState &&
      (chatbotState?.uiMessageHistory?.length ?? 0) > 0
    );
  }

  public onContentPainted() {
    this.uiRendering = false;
  }

  public retryLoad() {
    this.store.dispatch(new ChatbotActions.LoadLatest());
  }
}
